import React, { useEffect, useRef, useState } from 'react'
import { Card, CardContent } from '../../components/ui/card'
import { goToHomePage, hideLoader, showLoader } from '../../helpers/Utils'
import { Input } from '../../components/ui/input'
import { Button } from '../../components/ui/button'
import { Label } from '../../components/ui/label'
import ReCAPTCHA from 'react-google-recaptcha'
import '../../assets/styleSheets/login.scss'
import { CDN_URL } from '../../constants/siteConstant'
import { useTranslation } from 'react-i18next'
import { tryCustomRegistration } from 'src/services/viewRequest'
import { IconInfoCircleFilled, IconX } from '@tabler/icons-react'

const errorStyle = {
  fontSize: '12px',
  color: 'red',
  marginTop: '4px'
}
export default function Register () {
  const [activeStep, setActiveStep] = useState(1)
  const [displayPilotPhaseBanner, setDisplayPilotPhaseBanner] = useState(true)
  const recaptchaRef = useRef()

  const [formData, setFormData] = useState({
    email: '',
    workshopName: '',
    recaptcha: '',
    workshopNameError: '',
    emailError: ''
  })
  const [validationErrors, setValidationErrors] = useState({
    email: '',
    workshopName: ''
  })
  const { t } = useTranslation(['viewRequest'])

  const [debounceTimeout, setDebounceTimeout] = useState(null)

  useEffect(() => {
    return () => {
      if (debounceTimeout) {
        clearTimeout(debounceTimeout)
      }
    }
  }, [])

  const handleChange = (event) => {
    setFormData({ ...formData, [event.target.name]: event.target.value })
    setValidationErrors({ ...validationErrors, [event.target.name]: '' })
    if (debounceTimeout) {
      clearTimeout(debounceTimeout)
    }
    const newTimeout = setTimeout(() => {
      if (recaptchaRef.current) {
        recaptchaRef.current.reset()
      }
    }, 1000)

    setDebounceTimeout(newTimeout)
  }

  const onChangeCallback = (token) => {
    setFormData({ ...formData, recaptcha: token })
  }

  const handleSubmit = async (event) => {
    event.preventDefault()
    showLoader()
    const errors = {}
    if (!formData.email.trim()) {
      errors.email = t('emailRequired')
    }
    if (!formData.workshopName.trim()) {
      errors.workshopName = t('Dieses Feld ist erforderlich')
    }
    if (Object.keys(errors).length === 0) {
      const signupResponse = await tryCustomRegistration({
        workshop_primary_email: formData?.email,
        workshop_account_name: formData.workshopName,
        recaptcha: formData.recaptcha
      })
      if (signupResponse) {
        setActiveStep(activeStep + 1)
      }
      hideLoader()
    } else {
      hideLoader()
      setValidationErrors(errors)
    }
  }

  function handleKeyPress (event) {
    if (event.key === 'Enter') {
      event.preventDefault()
      handleSubmit()
    }
  }

  return (
    <div className='login-container'>
      <div className='logo' onClick={goToHomePage} />
      <Card className='login-card p-8'>
        {activeStep === 2
          ? (
            <CardContent
              style={{
                backgroundColor: 'white',
                display: 'flex',
                maxWidth: '480px',
                flexDirection: 'column'
              }}
            >
              <div>
                <h2 className='font-weight-700 gp-text24 tracking-0 gp-lh28 gp-mb8'>
                  {t('invitationSent')}
                </h2>
                <p
                  style={{
                    fontSize: '0.875rem',
                    color: '#555',
                    marginBottom: '1.5rem'
                  }}
                >
                  {t('checkInbox')}
                </p>
              </div>
              {displayPilotPhaseBanner && (
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    backgroundColor: '#E6F4FE',
                    padding: '12px',
                    borderRadius: '8px'
                  }}
                >
                  <div
                    style={{
                      // backgroundColor: 'red',
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center'
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px'
                      }}
                    >
                      <IconInfoCircleFilled
                        height={16}
                        width={16}
                        fill='#0D74CE'
                      />
                      <span
                        style={{
                          fontSize: '14px',
                          fontWeight: '600',
                          lineHeight: '20px',
                          color: '#1C2024'
                        }}
                      >
                        {t('pilotPhase')}
                      </span>
                    </div>
                    <IconX
                      onClick={() => setDisplayPilotPhaseBanner(false)}
                      height={16}
                      width={16}
                      color='#000509E3'
                    />
                  </div>
                  <span
                    style={{
                      padding: '8px 24px 0px 24px',
                      fontSize: '12px',
                      fontWeight: '400',
                      lineHeight: '16px',
                      color: '#1C2024'
                    }}
                  >
                    {t('pilotPhaseContent')}
                  </span>
                </div>
              )}
              <Button
                className='bg-[#6926D9]'
                onClick={goToHomePage}
                style={{
                  display: 'flex',
                  marginTop: '24px'
                }}
              >
                {t('Schließen')}
              </Button>
            </CardContent>
            )
          : (
            <>
              <div
                className='login-left flex-center flex-d-column'
                style={{
                  backgroundImage: `url('${CDN_URL}/workshop-portal/static-images/login-bg.svg')`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center'
                }}
              >
                <div className='font-weight-700 gp-text24 text-white tracking-0 gp-lh28 gp-mb20'>
                  {t('pageTitle')}
                </div>
                <p>
                  {t('pageSubtitle')}
                </p>
              </div>
              <CardContent className='login-right gp-pr0'>
                <h2 className='font-weight-700 gp-text24 tracking-0 gp-lh28 gp-mb8'>
                  {t('requestInvitation')}
                </h2>
                <p className='subheading'>
                  {t('createAccountSubheanding')}
                </p>

                <div className='form-group gp-mb16'>
                  <Label htmlFor='email' className='gp-mb8 required'>
                    {t('email')}
                  </Label>
                  <Input
                    id='email'
                    name='email'
                    type='email'
                    placeholder={t('yourEmailAddress')}
                    onChange={handleChange}
                  />
                  <span style={errorStyle}>{validationErrors.email || ''}</span>
                </div>

                <div className='form-group'>
                  <Label htmlFor='workshopName' className='gp-mb8 required'>
                    {t('nameOfTheCompany')}
                  </Label>
                  <div className='password-wrapper'>
                    <Input
                      id='workshopName'
                      name='workshopName'
                      placeholder='Werkstattname'
                      onKeyPress={handleKeyPress}
                      onChange={handleChange}
                    />
                    <span style={errorStyle}>
                      {validationErrors.workshopName || ''}
                    </span>
                  </div>
                </div>

                <div className='form-group'>
                  <div className='gp-mt20'>
                    <ReCAPTCHA
                      // eslint-disable-next-line no-undef
                      sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                      onChange={onChangeCallback}
                      ref={recaptchaRef}
                    />
                  </div>
                </div>

                <Button
                  className='login-button bg-[#6926D9]'
                  disabled={!formData.recaptcha}
                  onClick={handleSubmit}
                >
                  {t('sending')}
                </Button>

                <p className='password-reset'>
                  {t('agreeTermsCondition')}
                  <a
                    href='https://goparts.tech/privacy-policy'
                    target='_blank'
                    rel='noreferrer'
                  >
                    {' '}
                    {t('privacyPolicy')}
                  </a>{' '}
                  {t('andThe')}
                  <a
                    href='https://goparts.tech/terms-and-conditions'
                    target='_blank'
                    rel='noreferrer'
                  >
                    {' '}
                    {t('termsAndConditions')}
                  </a>{' '}
                  zu.
                </p>
              </CardContent>
            </>
            )}
      </Card>
    </div>
  )
}
